<nav class="header-nav" aria-label="Primary navigation">
  <!-- Brand Logo -->
  <button class="brand" routerLink="/dashboard" type="button" aria-label="Go to dashboard">
    <img ngSrc="assets/az-logo.svg" alt="AstraZeneca logo" width="40" height="40">
    <span class="brand-name">BeFair Tool</span>
  </button>

  <!-- Navigation Actions -->
  <div class="nav-actions">
    <!-- Notifications -->
    <button type="button" class="action-btn" aria-label="View notifications">
      <mat-icon>notifications</mat-icon>
    </button>

    <!-- Role Switcher -->
    @if (currentUser?.system_role_info; as roleInfo) {
      @if (roleInfo.length > 1) {
        <button
          type="button"
          class="role-switcher"
          aria-label="Select user role"
          [matMenuTriggerFor]="roleMenu">
          <mat-icon>swap_horiz</mat-icon>
          <span class="role-text">
            @if (selectedRole; as role) {
              {{ role.role_name }}@if (role.market && role.showMarket) { ({{ role.market }}) }
            }
          </span>
          <mat-icon class="dropdown-icon">expand_more</mat-icon>
        </button>

        <mat-menu #roleMenu="matMenu" panelClass="role-menu-panel" [overlapTrigger]="false">
          @for (role of rolesWithMarket; track role.index) {
            <button
              mat-menu-item
              class="role-menu-item"
              [class.active]="selectedRoleIndex === role.index"
              (click)="switchRole(role.index)">
              <mat-icon>{{ role.icon }}</mat-icon>
              <span>{{ role.role_name }}@if (role.market && role.showMarket) { ({{ role.market }}) }</span>
            </button>
          }
        </mat-menu>
      } @else if (roleInfo.length === 1) {
        <div class="role-badge">
          <mat-icon>{{ singleRoleIcon }}</mat-icon>
          <span>{{ roleInfo[0]?.role_name }}</span>
        </div>
      }
    }

    <!-- User Profile -->
    @if (currentUser; as user) {
      <div class="user-profile">
        <span class="user-name" [title]="user.first_name + ' ' + user.last_name">
          {{ user.first_name }} {{ user.last_name }}
        </span>
        <div class="avatar-wrapper">
          @if (profileImageUrl) {
            <img class="avatar" width="36" height="36" appDefaultImage [alt]="user.first_name + ' ' + user.last_name" [userName]="user.first_name + ' ' + user.last_name" [ngSrc]="profileImageUrl">
          } @else {
            <span class="avatar-placeholder">{{ userInitial }}</span>
          }
        </div>
      </div>
    }
  </div>
</nav>
